import {
    FoodLogItemType,
    FoodLogType,
    PaginationType,
    userType,
} from "../../../DTO";
import { Api } from "../../api";
import { convertToAttachmentsTypeList } from "../../peer-group/post";
import { convertToPaginationType } from "../../help";

interface IFoodLogListParams {
    appUser: userType;
    userId: number;
    date?: string;
    type?: string;
    status?: string;
    currentPage?: number;
}

export const FoodLogList = (foodInput: IFoodLogListParams) => {
    return new Promise<{ food: FoodLogType[]; pagination: PaginationType }>(
        (resolve, reject) => {
            const api = new Api({
                method: "get",
                path: `food-log/user/${foodInput.userId}`,
                header: {
                    Authorization: `Bearer ${foodInput.appUser.access_token}`,
                },
                params: {
                    date: foodInput.date,
                    type: foodInput.type,
                    status: foodInput.status,
                    page: foodInput?.currentPage,
                },
            });

            return api
                .call()
                .then((data: any) =>
                    resolve({
                        food: convertToFoodTypeList(data.data),
                        pagination: convertToPaginationType(data.meta),
                    }),
                )
                .catch((err) => reject(err.data.message));
        },
    );
};

export const convertToFoodTypeList = (data: any[]): FoodLogType[] => {
    return data.map((element) => convertToFoodType(element));
};

export const convertToFoodType = (data: any): FoodLogType => {
    let out: FoodLogType = {
        id: data?.id,
        type: data?.type,
        after_midnight: data?.after_midnight,
        attachments: data?.attachments,
        created_at: data?.created_at,
        duration_time: data?.duration_time,
        healthiness: data?.healthiness,
        hungry: data?.hungry,
        on_time: data?.on_time,
        portion: data?.portion,
        updated_at: data?.updated_at,
        want_to_eat: data?.want_to_eat,
        is_side: data?.is_side,
        items: convertToFoodItemTypeList(data?.items),
        traffic_light: data?.traffic_light,
        ai_summary: data?.ai_summary,
        total_nutrition: data?.total_nutrition,
        status: data?.status,
        day_id: data?.day_id,
        daily_task_id: data?.daily_task_id,
    };

    return out;
};

export const convertToFoodItemTypeList = (data: any[]): FoodLogItemType[] => {
    return data.map((item) => convertToFoodItemType(item));
};

export const convertToFoodItemType = (data: any): FoodLogItemType => {
    let out: FoodLogItemType = {
        id: data?.id,
        name: data?.name,
        portion: {
            amount: data?.portion?.amount,
            unit: data?.portion?.unit,
            display: data?.portion?.display,
        },
        nutrition: {
            calories: data?.nutrition?.calories,
            protein: data?.nutrition?.protein,
            carbohydrates: data?.nutrition?.carbohydrates,
            fat: data?.nutrition?.fat,
            fiber: data?.nutrition?.fiber,
            sugar: data?.nutrition?.sugar,
            sodium: data?.nutrition?.sodium,
            cholesterol: data?.nutrition?.cholesterol,
            saturated_fat: data?.nutrition?.saturated_fat,
            trans_fat: data?.nutrition?.trans_fat,
        },
        description: data?.description,
        sugar_risk: data?.sugar_risk,
        sugar_risk_uncertain: data?.sugar_risk_uncertain,
    };

    return out;
};
